import React from 'react'
import { graphql } from 'gatsby'
import style from './flex.mod.scss'

const Flex = ({ children }) => {
  return (
    <div className={style.flex}>
      <div className={style.flex__wrap}>{children}</div>
    </div>
  )
}

export default Flex

export const query = graphql`
  fragment SocialList on DatoCmsSocialMediaList {
    background
    padding
    id
    heading
    moduleStyle
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    items {
      ...SocialLink
    }
    model {
      apiKey
    }
  }
`
